var React = require('react');

function CloseIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1.36283 8.26155L8.46129 1.1631C8.64846 0.975933 8.61596 0.638052 8.38895 0.411045C8.16194 0.184038 7.82406 0.15154 7.63689 0.338709L0.53844 7.43716C0.35127 7.62433 0.383769 7.96221 0.610776 8.18922C0.837782 8.41623 1.17566 8.44872 1.36283 8.26155Z","fill":"white","key":0}),React.createElement("path",{"d":"M8.46138 7.43734L1.36293 0.338885C1.17576 0.151715 0.837881 0.184213 0.610874 0.41122C0.383867 0.638227 0.351369 0.976108 0.538539 1.16328L7.63699 8.26173C7.82416 8.4489 8.16204 8.4164 8.38905 8.18939C8.61606 7.96239 8.64855 7.62451 8.46138 7.43734Z","fill":"white","key":1})]);
}

CloseIcon.defaultProps = {"width":"9","height":"9","viewBox":"0 0 9 9","fill":"none"};

module.exports = CloseIcon;

CloseIcon.default = CloseIcon;



//////////////////
// WEBPACK FOOTER
// /node_modules/svg-react-loader/lib/loader.js?name=CloseIcon!./components/header/assets/close.svg
// module id = TsUh
// module chunks = 0